import { pageLoaded } from "venuescanner-js/tools/elemental";
import { detectedPathEvent } from "./path_events";
import { trackEvent } from "./track_event";
import { eventData } from "./event_data";
export const pageListener = (data = {}) => {
  pageLoaded(() => {
    const path = detectedPathEvent();
    if (path) trackEvent(path, eventData(path, data));
  });
};
